export const WEB_STORAGE_KEYS = {
  EE_LOGIN_USER_NAME: 'EE_USER_ID',
  LOGIN_STATUS: 'LOGIN_STATUS',
  USER_ID: 'USER_ID'
}